import styled from 'styled-components'

export const ApiDocsSectionWrapper = styled.section`
  width: 100%;

  > table td:first-child {
    min-width: 240px;
    font-weight: bold;
  }

  em {
    font-weight: normal;
    font-style: italic;
  }
`
